import React from 'react';
import styled from 'styled-components';
import { ItemProperty } from './CommonStyles';

interface ICartItemShade {
  hexValue: string;
  shadeName: string;
}

interface IShadeHexValue {
  hexValue: string;
}

export const CartItemShadeWrapper = styled(ItemProperty)`
  display: flex;
`;

export const CartItemShadeName = styled(ItemProperty)`
  font-size: 12px;
  margin-bottom: 4px;
`;

export const CartItemShadeSwatch = styled.div<IShadeHexValue>`
  background-color: #${({ hexValue }): string => hexValue};
  height: 16px;
  width: 16px;
  margin-right: 8px;
  border-radius: 100%;
`;

const renderShadeSwatch = (hexValue: string): JSX.Element[] => hexValue.split(',').map((color: string) => (
  <CartItemShadeSwatch
    key={color}
    hexValue={color}
  />
));

const CartItemShade = ({ hexValue, shadeName }: ICartItemShade): JSX.Element => (
  <CartItemShadeWrapper className="cart-item-child cart-item-shade-name">
    {hexValue && renderShadeSwatch(hexValue)}
    <CartItemShadeName>
      {shadeName}
    </CartItemShadeName>
  </CartItemShadeWrapper>
);

export default CartItemShade;
